// Based on TiMessengerTestTreiber.yaml 2.0.0
import { Injectable } from '@angular/core';
import { AuthFlows } from '../../../shared-api/authFlows';
import { AuthStageName } from '../../../shared-api/authStageName';
import { Login } from '../../../shared-api/login';
import { Account } from '../../../shared-api/account';
import { LoginLogoutService as ApiLoginLogoutService } from '../../../shared-api/loginLogout.service';

/**
 * Der LoginLogoutService stellt das An- und Abmelden bereit.
 * Implementation of the mandatory Login/Logout API of the Gematik TI-M Testtreiber
 * Umgesetzte AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte
 */
@Injectable({
  providedIn: 'root'
})
export class LoginLogoutService implements ApiLoginLogoutService {
  /**
   * Retrieve list of possible authentication flows
   */
  public async getLoginOptions(): Promise<AuthFlows> {
    return { flows: [{ stages: [AuthStageName.BasicAuth] }] } as AuthFlows;
  }

  /**
   * Login to an account. If no login data is provided, a preconfigured account should be used.
   * In case the device has a HBA/SMC-B its data should be used.
   *
   * Nicht implementiert: Der Login läuft im TIM-Pro-Client ausschließlich über Keycloak (OAuth/OIDC).
   * Der Testtreiber nutzt diese Methode nicht — er fährt den Browser-Login direkt via
   * `loginViaStorageState` (e2e/setup/login-user.ts) aus `DeviceDriver.login`, bevor er überhaupt
   * in-Page auf `window.loginLogoutService` zugreift. Diese Stub-Implementation existiert nur,
   * um den `LoginLogoutService`-Contract des Shared-API-Interfaces zu erfüllen.
   * @param login
   */
  public async login(login: Login): Promise<Account> {
    throw new Error('not implemented - OAuth login');
  }

  /**
   * Logout of account.
   *
   * Nicht implementiert: analog zu {@link login} läuft der Logout über Keycloak. Der Testtreiber
   * klickt die Logout-Buttons via `clickLogoutButtons` / `logoutOrgAdmin` (common/helpers/login.helper.ts)
   * in der UI; diese Methode wird nie aufgerufen.
   */
  public async logout(): Promise<void> {
    throw new Error('not implemented - OAuth logout');
  }
}
